const knownComponents = {};

const initializeComponent = (name, component) => {
  document.querySelectorAll(`[data-component=${name}]`).forEach((el) => {
    el.dataset.initialized = true;
    if (typeof component === 'undefined') {
      console.log(`${name} is undefined`);
      return;
    }
    component(el);
  })
}

const register = (name, component) => {
  knownComponents[name] = component;
  document.addEventListener('DOMContentLoaded', () => {
    initializeComponent(name, component);
  })
}

const callback = (mutationList) => {
  mutationList.forEach(
    (item) => {
      if (Object.hasOwn(item.target.dataset, 'component') && !Object.hasOwn(item.target.dataset, 'initialized')) {
        initializeComponent(item.target.dataset.component, knownComponents[item.target.dataset.component]);
      }

      const components = item.target.querySelectorAll('[data-component]');
      if (!components.length) {
        return;
      }
      components.forEach((component) => {
        if (Object.hasOwn(component.dataset, 'initialized')) {
          return;
        }
        initializeComponent(component.dataset.component, knownComponents[component.dataset.component]);
      })
    }
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(callback);
  observer.observe(
    document.querySelector('.main-content'),
    {
      attributes: false,
      childList: true,
      subtree: true
    }
  );
});


export {
  register
}
